import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/auth/google": [14],
		"/auth/login": [15],
		"/auth/logout": [16],
		"/auth/lost-password": [17],
		"/auth/password": [18],
		"/auth/plan": [19],
		"/auth/signup": [20],
		"/(accounts)/billing": [4,[2,3]],
		"/(accounts)/billing/checkout": [5,[2,3]],
		"/(accounts)/billing/exit-survey": [6,[2,3]],
		"/(accounts)/billing/payment-method": [7,[2,3]],
		"/(accounts)/billing/plans": [8,[2,3]],
		"/(accounts)/billing/portal": [9,[2,3]],
		"/(accounts)/billing/setup": [10,[2,3]],
		"/coupon": [21],
		"/nanowrimo/auth": [22],
		"/onboarding/found": [23],
		"/onboarding/genre": [24],
		"/(accounts)/password": [11,[2]],
		"/(accounts)/profile": [12,[2]],
		"/(accounts)/refer": [13,[2]],
		"/thank-you": [25]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';